import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import NameCell from '../Table/NameCell';
import i18n from '../../i18n';
import Action from './Action';
import { CoachStatus } from '../../types/coach';

const formatPhoneNumber = (phoneNumber: string): string => {
  const countryCode = phoneNumber.slice(0, 3);
  const localNumber = phoneNumber.slice(3);
  const formattedNumber = `(${countryCode}) ${localNumber.slice(0, 5)}-${localNumber.slice(5)}`;
  return formattedNumber;
};

const renderStatusInfo = (status: CoachStatus) => {
  let color: string;
  let capitalizedStatus: string;
  const theme = useTheme();
  const { t } = useTranslation();

  switch (status) {
    case CoachStatus.PENDING:
      color = '#F9BC60';
      capitalizedStatus = 'applicationView.pending';
      break;
    case CoachStatus.APPROVED:
      color = theme.palette.primary.main;
      capitalizedStatus = 'applicationView.approved';
      break;
    case CoachStatus.REJECTED:
      color = theme.palette.text.disabled;
      capitalizedStatus = 'applicationView.rejected';
      break;
    default:
      color = 'black';
      capitalizedStatus = 'applicationView.unknown';
      break;
  }
  return (
    <Typography variant="bodyRegular" color={color}>
      {t(capitalizedStatus)}
    </Typography>
  );
};

export interface ICoachRow {
  id: string;
  avatar: string;
  name: string;
  firstName: string;
  lastName: string;
  profilePic: string;
  email: string;
  profilePicture: string;
  tp: string;
  status: CoachStatus;
  country: string;
}

interface IRenderCellParams {
  row: ICoachRow;
  value: string | boolean;
}

interface IColumn {
  field: string;
  headerName: string;
  hide?: boolean;
  width?: number;
  disableColumnMenu?: boolean;
  sortable?: boolean;
  flex?: number;
  renderCell?: (_params: IRenderCellParams) => React.ReactNode;
  renderHeader?: (_params: IRenderCellParams) => React.ReactNode;
}
const columns: IColumn[] | undefined = [
  { field: 'id', headerName: 'ID', hide: true },
  // {
  //   field: 'PMCNo',
  //   headerName: i18n.t('coachesTable.PMCNo'),
  //   width: 500,
  //   disableColumnMenu: true,
  //   sortable: false,
  //   flex: 1.4,
  //   renderCell: (params: IRenderCellParams) => (
  //     <Typography variant="bodyRegular">
  //       {' '}
  //       {/* Todo */}
  //       {params.row.firstName} {params.row.lastName}
  //     </Typography>
  //   ),
  //   renderHeader: () => (
  //     <Box display="flex">
  //       <Typography variant="meta">{i18n.t('coachesTable.PMCNo')}</Typography>
  //     </Box>
  //   ),
  // },
  {
    field: 'coachName',
    headerName: i18n.t('coachesTable.coachName'),
    width: 500,
    disableColumnMenu: true,
    sortable: false,
    flex: 2,
    renderCell: (params: IRenderCellParams) => (
      <NameCell
        avatar={params.row.profilePic}
        firstName={params.row.firstName}
        lastName={params.row.lastName}
      />
    ),
    renderHeader: () => (
      <Box display="flex">
        <Typography variant="meta">{i18n.t('coachesTable.coachName')}</Typography>
      </Box>
    ),
  },
  {
    field: 'email',
    headerName: i18n.t('coachesTable.email'),
    width: 150,
    disableColumnMenu: true,
    sortable: false,
    flex: 2,
    renderHeader: () => (
      <Box display="flex">
        <Typography variant="meta">{i18n.t('coachesTable.email')}</Typography>
      </Box>
    ),
    renderCell: (params: IRenderCellParams) => (
      <Typography variant="bodyRegular">{params.row.email}</Typography>
    ),
  },
  {
    field: 'tp',
    headerName: i18n.t('coachesTable.tp'),
    width: 100,
    disableColumnMenu: true,
    sortable: false,
    flex: 2,
    renderHeader: () => (
      <Box display="flex">
        <Typography variant="meta">{i18n.t('coachesTable.tp')}</Typography>
      </Box>
    ),
    renderCell: (params: IRenderCellParams) => (
      <Typography variant="bodyRegular">
        {params.row.tp ? formatPhoneNumber(params.row.tp) : params.row.tp}
      </Typography>
    ),
  },
  // {
  //   field: 'country',
  //   headerName: i18n.t('coachesTable.country'),
  //   width: 100,
  //   disableColumnMenu: true,
  //   sortable: false,
  //   flex: 1.2,
  //   renderHeader: () => (
  //     <Box display="flex">
  //       <Typography variant="meta">{i18n.t('coachesTable.country')}</Typography>
  //     </Box>
  //   ),
  //   renderCell: (params: IRenderCellParams) => (
  //     <Typography variant="bodyRegular">{params.row.country}</Typography>
  //   ),
  // },
  {
    field: 'status',
    headerName: i18n.t('coachesTable.status'),
    width: 100,
    disableColumnMenu: true,
    sortable: false,
    flex: 1.2,
    renderHeader: () => (
      <Box display="flex">
        <Typography variant="meta">{i18n.t('coachesTable.status')}</Typography>
      </Box>
    ),
    renderCell: (params: IRenderCellParams) => renderStatusInfo(params.row.status),
  },
  {
    field: 'approve',
    headerName: '',
    disableColumnMenu: true,
    sortable: false,
    flex: 0.3,
    renderCell: (params: IRenderCellParams) => <Action row={params.row} action="approve" />,
  },
  {
    field: 'reject',
    headerName: '',
    disableColumnMenu: true,
    sortable: false,
    flex: 0.4,
    renderCell: (params: IRenderCellParams) => <Action row={params.row} action="reject" />,
  },
];

export default columns;
